import SelectBirthDateMobile from "./SelectBirthDateMobile";
import { Trans } from "react-i18next";
import i18next from "i18next";
import i18n from "./../../../i18n";
import moment from "moment/moment.js";

import { checkAndGetSessionStorageValue } from "../../../features/utils";

function setBirthDate({ name, value, fields, setFields }) {
    const keys = ["day", "month", "year"];

    const birthdate = keys.reduce((obj, key) => {
        obj[key] = key === name ? value : fields.birthdate[key];
        return obj;
    }, {});

    const birthdateSelected = keys.reduce((bool, key) => {
        if (bool === false) return false;
        return birthdate[key] ? true : false;
    }, null);

    setFields({
        birthdateSelected,
        birthdate,
    });
}

async function onBlurCalled( actions, fields, setFields) {
    if (fields.birthdateSelected && checkAndGetSessionStorageValue("isTravelAid2") !== "true" && sessionStorage.getItem("dateToValidate1") === "true") {
        actions.CheckAndGetRiskFactorDetails(actions, fields, setFields);
    } else {
         localStorage.removeItem("riskfactors");
         setFields({
             riskFactorVal: "",
             childBirthName: checkAndGetSessionStorageValue("isTravelAid2") !== "true" ? "" : "Recent childbirth",
             pregnant: "",
             selectChildBirth: "",
             selectRecentPhysicalInjury: "",
             isRiskFactorApiCompleted: false,
             isRiskFactorCompleted: false,
         });
    }
}

function defaultMonth(value){
    var monthStyle=document.getElementById("ddMonth")
    if(value !== "00"){
        monthStyle.classList.add("monthStyling");
        monthStyle.classList.remove("defaultMonth");
        sessionStorage.setItem("dateToValidate1", false)
    }else{
        monthStyle.classList.remove("monthStyling");
        monthStyle.classList.add("defaultMonth");
        sessionStorage.setItem("dateToValidate1", true)
    }
}

function dateValidate(fields){
    let today = moment();
    var birthdate =
      fields.birthdate.year +
      "/" +
      fields.birthdate.month +
      "/" +
      fields.birthdate.day;
    let diff = today.diff(birthdate);
    sessionStorage.setItem("dateToValidate1", false);
    let dateToValidate = moment(birthdate, "YYYY/MM/DD", true);
    if (!dateToValidate.isValid() || diff < 0) {
      sessionStorage.setItem("dateToValidate1", false);
    } else {
      sessionStorage.setItem("dateToValidate1", dateToValidate.isValid());
    }
}

function errorCheck(invalidFields){
    if (
        document.getElementById('ddMonth').value != '00' 
        && (document.getElementById('txtDay').value != '' && document.getElementById('txtYear').value != '' )
        && (document.getElementById('txtDay').value.length > 0 && document.getElementById('txtYear').value.length > 0))
    {
        invalidFields.birthdate = '';
        document.getElementById('ddMonth').setAttribute('class', 'dob-3-field-month ');
        document.getElementById('txtDay').setAttribute('class', 'dob-3-field-day ');
        document.getElementById('txtYear').setAttribute('class', 'dob-3-field-year ');
        document.getElementById('errorDOB').style.display = 'none';
    }
    else{
        document.getElementById('ddMonth').setAttribute('class', 'dob-3-field-month is-error');
        document.getElementById('txtDay').setAttribute('class', 'dob-3-field-day is-error');
        document.getElementById('txtYear').setAttribute('class', 'dob-3-field-year is-error');
        document.getElementById('errorDOB').style.display = 'block';                  
    }
}

function dayComponent(invalidFields, fields, setFields, actions, placeholder1) {
    return (
    <div className="standby-page-section-row">
        <input
            type="number"
            id="txtDay"
            placeholder={placeholder1}
            aria-label={i18next.t("findcareoption.Start.DOB")}
            className={`dob-3-field-day ${invalidFields.birthdate ? "is-error" : ""}`}
            maxLength="2"
            min="1"
            max="31"
            value={fields.birthdate.day}
            onFocus={(e) => {
                fields.birthdate.day = e.currentTarget.value = "";
                sessionStorage.setItem("dateToValidate1", false);

                setBirthDate({
                    name: "day",
                    value: (e.currentTarget.value = ""),
                    fields,
                    setFields,
                });
            }}
            onBlur = {() => {
                errorCheck(invalidFields);
                dateValidate(fields);
                if (fields.birthdate.day.toString().length === 1)
                  fields.birthdate.day = "0" + fields.birthdate.day;
                if(sessionStorage.getItem("dateToValidate1") === "true")
                {                
                    onBlurCalled( actions, fields, setFields);
                }
            }}
            onKeyPress={(e) => {
                if (fields.birthdate.day.length == 2) e.preventDefault();
                return false;
            }}
            onChange={(e) => {
                e.currentTarget.focus();
                    setBirthDate({
                        name: "day",
                        value: e.target.value,
                        fields,
                        setFields,
                    });
                }
            }
        />
        {/* <span id="errorDay" className="errormessage-phone" style={{ display: invalidFields.birthdate ? "block" : "none" }}>Day is required</span> */}
    </div>
    );
}

function monthComponent(invalidFields, fields, setFields, actions, state){
    return(
    <div className="standby-page-section-row">
        <select
            id="ddMonth"
            title="Month Name"
            aria-label={i18next.t("findcareoption.Start.DOB")}
            value={fields.birthdate.month}
            className={`dob-3-field-month ${invalidFields.birthdate 
                ? "is-error" : state.triageRequest.birthdate.month !== '00' 
                && state.triageRequest.birthdate.month !== '' ? 'monthStyling' 
                        : "defaultMonth"}`}
            onBlur = {(e) => {
                console.log('target value: ', e.target.value);
                errorCheck(invalidFields);
                dateValidate(fields);
                if(sessionStorage.getItem("dateToValidate1") === "true"){
                onBlurCalled( actions, fields, setFields);
                }
            }}
            onChange={(e) => {
                setBirthDate({
                    name: "month",
                    value: e.target.value,
                    fields,
                    setFields,
                });
            }}
            onClick={(e) => defaultMonth(e.target.value)}
        >
            <option value="00">{i18next.t("findcareoption.Start.Month")}</option>
            <option value="01">
                {i18next.t("findcareoption.Start.Months.01")}
            </option>
            <option value="02">
                {i18next.t("findcareoption.Start.Months.02")}
            </option>
            <option value="03">
                {i18next.t("findcareoption.Start.Months.03")}
            </option>
            <option value="04">
                {i18next.t("findcareoption.Start.Months.04")}
            </option>
            <option value="05">
                {i18next.t("findcareoption.Start.Months.05")}
            </option>
            <option value="06">
                {i18next.t("findcareoption.Start.Months.06")}
            </option>
            <option value="07">
                {i18next.t("findcareoption.Start.Months.07")}
            </option>
            <option value="08">
                {i18next.t("findcareoption.Start.Months.08")}
            </option>
            <option value="09">
                {i18next.t("findcareoption.Start.Months.09")}
            </option>
            <option value="10">
                {i18next.t("findcareoption.Start.Months.10")}
            </option>
            <option value="11">
                {i18next.t("findcareoption.Start.Months.11")}
            </option>
            <option value="12">
                {i18next.t("findcareoption.Start.Months.12")}
            </option>
        </select>
   </div>
    );
}

function yearComponent(invalidFields, fields, setFields, actions, placeholder1){
    return(
    <div className="standby-page-section-row">
        <input
            type="number"
            id="txtYear"
            placeholder={placeholder1}
            aria-label={i18next.t("findcareoption.Start.DOB")}
            className={`dob-3-field-year ${invalidFields.birthdate ? "is-error" : ""}`}
            maxLength="4"
            min="1900"
            max="2200"
            value={fields.birthdate.year}
            onBlur = {() => {
                var dateToValidate = dateValidate(fields);
                console.log(dateToValidate);
                if(sessionStorage.getItem("dateToValidate1") === "true"){
                onBlurCalled( actions, fields, setFields);
                }
                errorCheck(invalidFields);
            }}
            onFocus={(e) => {
                sessionStorage.setItem("dateToValidate1", false);
                fields.birthdate.year = e.currentTarget.value = "";
                setBirthDate({
                    name: "year",
                    value: (e.currentTarget.value = ""),
                    fields,
                    setFields,
                });
            }}
            onChange={(e) => {
                    e.currentTarget.focus();
                    setBirthDate({
                        name: "year",
                        value: e.currentTarget.value,
                        fields,
                        setFields,
                    });
                }
            }
            onKeyPress={(e) => {
                if (fields.birthdate.year.length == 4) e.preventDefault();
                return false;
            }}
        />
        {/* <span id="errorYear" className="errormessage-phone" style={{ display: invalidFields.birthdate ? "block" : "none" }}>Year is required</span> */}
    </div>
    );
}

export default ({ fields, invalidFields, setFields, state, actions }) => (
    <>
        <fieldset>
            <div aria-labelledby="legendDOB" className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center">
                <div className={`${!(state && state.isTravelAid2) ? "standby-col standby-col-shrink standby-form-legend" : "dob-label"}`}>
                    <legend>
                        {!state.isTravelAid2 ?
                            <h2 className="standby-form-legend-text">
                                <Trans i18nKey="findcareoption.Start.DOB">What's your birthdate?</Trans>
                            </h2>
                        :
                            <h5 className="standby-form-legend-text">
                                <Trans i18nKey="findcareoption.Start.DOB">What's your birthdate?</Trans>
                            </h5>
                        }
                    </legend>
                </div>
                <div id="legendDOB" className="standby-col standby-form-inline-fields mmStyle" style={{ flexWrap: "nowrap" }}>
                    {/* Task-1917 MM/DD/YYYY Format. Just alternate dd/mm/yyyy to mm/dd/yyyy */}
                    {monthComponent(invalidFields, fields, setFields, actions, state)}
                    {dayComponent(invalidFields, fields, setFields, actions, `${i18next.t("findcareoption.Start.Day")}`)}
                    {yearComponent(invalidFields, fields, setFields, actions, `${i18next.t("findcareoption.Start.Year")}`)}
                </div>

            </div>
        </fieldset>
            
        <div id="errorDOB" className="errormessage-phone" 
            style={ invalidFields && invalidFields.birthdate 
                ? { display: "block" } 
                : { display: "none" } 
            }>
            {i18next.t("findcareoption.Start.errorMessages.errorDOB")}
        </div>
    </>
);
